module.exports = require('./'+ process.env.NODE_ENV + '.env.js');
